export const DetailsAccordionComponent = {
  bindings: {
    heading: '<'
  },
  transclude: {
    heading: 'heading'
  },

  controller: class {
    isExpanded: boolean = false;

    toggle() {
      return (this.isExpanded = !this.isExpanded);
    }
  },

  template: `<div class="details-accordion">
              <div data-test-selector="detailsAccordionHeading" class="details-accordion-header" ng-click="$ctrl.toggle()">
                <i ng-class="{'fa-minus-circle': $ctrl.isExpanded, 'fa-plus-circle': !$ctrl.isExpanded}" class="fa"></i>
                <span ng-transclude="heading"></span>
              </div>
              <div data-test-selector="detailsAccordionBody" class="details-accordion-body" ng-if="$ctrl.isExpanded">
                <ng-transclude></ng-transclude>
              </div>
            </div>`
};
